export const SOURCE_ICONS: Record<string, string> = {
  google_trends: 'TrendingUp',
  twitter: 'Twitter',
  reddit: 'MessageSquare',
  youtube: 'Youtube',
  yandex: 'Search',
  telegram: 'Send',
  vk: 'Users',
  ria_novosti: 'Newspaper',
  tass: 'Newspaper',
  lenta: 'Newspaper',
  rbc: 'Newspaper',
  reuters: 'Globe',
  bbc: 'Globe',
  cnn: 'Globe',
  ap_news: 'Globe',
  instagram: 'Camera',
  truth_social: 'MessageCircle',
  financial: 'DollarSign',
} as const;

export const SCORE_COLORS: Record<number, string> = {
  1: 'bg-red-600 text-white',
  2: 'bg-orange-500 text-white',
  3: 'bg-yellow-500 text-black',
  4: 'bg-lime-500 text-black',
  5: 'bg-green-500 text-white',
};

export const SOURCE_LABELS: Record<string, string> = {
  google_trends: 'Google Trends',
  twitter: 'Twitter / X',
  reddit: 'Reddit',
  youtube: 'YouTube',
  yandex: 'Яндекс Вордстат',
  telegram: 'Telegram',
  vk: 'ВКонтакте',
  ria_novosti: 'РИА Новости',
  tass: 'ТАСС',
  lenta: 'Лента.ру',
  rbc: 'РБК',
  reuters: 'Reuters',
  bbc: 'BBC News',
  cnn: 'CNN',
  ap_news: 'AP News',
  instagram: 'Instagram',
  truth_social: 'Truth Social',
  financial: 'Финансы',
};
